import React from 'react';
import { Box, LinearProgress } from '@mui/material';

interface LoadingBarProps {
  isLoading?: boolean;
}

const LoadingBar: React.FC<LoadingBarProps> = ({ isLoading = false }) => {
  if (!isLoading) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2000,
        height: 3,
      }}
    >
      <LinearProgress
        variant="indeterminate"
        sx={{
          '& .MuiLinearProgress-bar': {
            backgroundColor: '#0182c0',
          },
          backgroundColor: 'rgba(1, 130, 192, 0.2)',
        }}
      />
    </Box>
  );
};

export default LoadingBar;